import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { useLocation, navigate } from '@reach/router'
import { URLSearchParams } from 'universal-url'

import Pagination from '../pagination'
import ImageCard from '../image-card'

import { dateString } from '../../utils/date'

import './index.styl'
import landingImg from './news.png'

const NewsEvents = ({sitePrefix, pageData, screen}) => {
  const location = useLocation()
  const { t } =  useTranslation()

  const [pageProps, setPageProps] = useState({ current: 1, perPage: 10, total: 0 })

  const hanglePageClick = page => {
    const urlParams = new URLSearchParams(location.search)
    urlParams.set('p', page)
    navigate(`${location.pathname}?${urlParams.toString()}`)
    setPageProps({
      ...pageProps,
      current: page,
    })
  }

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search)
    setPageProps({
      ...pageProps,
      current: parseInt(urlParams.get('p')) || 1,
      total: pageData.length,
    })

  }, [])

  return (
    <div className="news-events">
      <ImageCard
        className="news-events__cover"
        imgUrl={landingImg}
        mode={screen === 'sm' || screen === 'xs' ? 'background' : 'image'}
      />
      <div className="news-events__main">
        {
          pageData.length > 0 
          ? (
            <>
              <ul className="news-events__item-list">
                {pageData
                  .slice(
                    (pageProps.current - 1) * pageProps.perPage,
                    pageProps.current * pageProps.perPage
                  )
                  .map(news => (
                    <li>
                      <a className="news-events__item" href={`${sitePrefix}/about/news-events/${news._id}/`}>
                        <div className="news-events__item-date">{dateString(news.time)}</div>
                        <div className="news-events__item-title">{news.title}</div>
                      </a>
                    </li>
                  ))}
              </ul>
              <div className="news-events__pagination-wrap">
                <Pagination
                  {...pageProps}
                  pageClick={hanglePageClick}
                  className="news-events__pagination"
                />
              </div>
            </>
          ) : (
            <div className="news-events__no-data">
              { t('news.noData') }
            </div>
          )
        }


      </div>
    </div>
  )
}

NewsEvents.propTypes = {}

export default NewsEvents
